import { useEffect, useState } from "react";

import useAccountManagementData from "../../../state/accountManagement/UseAccountManagementData";
import useAccountManagementCanvasData from "../../../state/accountManagement/accountManagementCanvas/UseAccountManagementCanvasData";

const useAccountManagementCanvas = () => {
  const { accountManagementState } = useAccountManagementData();
  const { accountManagementCanvasState, getAccountManagementCanvasByUserAccountId } = useAccountManagementCanvasData();

  const getAccountManagementCanvasInfo = () => {
    const userAccountId = accountManagementState.objData?.userAccountId;

    const getAccountManagementCanvasPromise = accountManagementState.isAdminView === true
      ? getAccountManagementCanvasByUserAccountId(userAccountId)
      : getAccountManagementCanvasByUserAccountId();

    if (getAccountManagementCanvasPromise ?? false) {
      getAccountManagementCanvasPromise.catch((e) => {
        //context error
      });
    }
  };

  useEffect(() => {
    if (accountManagementCanvasState.isObjLoaded === false) {
      getAccountManagementCanvasInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountManagementCanvasState.isObjLoaded]);

  return {
    isLoading: accountManagementCanvasState.isObjLoading,
    canvasObj: accountManagementCanvasState.objData
  };
};

export default useAccountManagementCanvas;